import Vue from 'vue'
import App from './App.vue'

import store from './store'
import router from './routes'
import vuetify from './plugins/vuetify';

const fb = require('./firebaseConfig.js')

Vue.config.productionTip = false

let app
fb.auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      store,
      router,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
